import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Container } from "@mui/material";
import Preparing from "./Preparing";
import Meeting from "./Meeting";
import Complete from "./Complete";

export const SCENE = {
    PREPARING: 'PREPARING',
    WAITING: 'WAITING',
    MEETING: 'MEETING',
    COMPLETE: 'COMPLETE',
    INTERRUPT: 'INTERRUPT',
    NOT_ALLOWED: 'NOT_ALLOWED',
}

export default function PrescriptionMedicationGuidance(props) {
    const [scene, setScene] = useState(SCENE.PREPARING)
    const location = useLocation();
    const search = location.search;
    const query = new URLSearchParams(search);
    const receiptedNumber = query.get('receiptedNumber')
    const roomId = query.get('id')

    return (
        <div style={{backgroundColor: '#fafafa', minHeight: '100vh'}}>
            <Container maxWidth="xs" sx={{py: '1rem'}} style={{backgroundColor: '#F1F4F7', minHeight: '100vh'}}>
                {scene === SCENE.PREPARING? (
                    <Preparing setScene={setScene}/>
                ): (scene === SCENE.WAITING || scene === SCENE.MEETING)? (
                    <Meeting scene={scene} receiptedNumber={receiptedNumber} roomId={roomId} setScene={setScene}/>
                ): (
                    <Complete setScene={setScene} scene={scene}/>
                )}
            </Container>
        </div>
    )
}